module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_question-12a46ba1e9dc478cee19779f3daf4d17.svg";